import { styled } from "@mui/material";
import { useNavigate, useSearchParams, createSearchParams, useParams } from "react-router-dom";

import { CountryModel } from "../../shared/models/countryModel";
import { useAppSelector } from "../../../redux/store";

import Message from "../../components/message";
import { MessageSections } from "../../components/message/message";

const Wraper = styled("div") <{ selected?: boolean }>`
  cursor: pointer;
  padding: 10px;
  border-radius: 10px;
  color: ${(props) => props.selected ? "#087E38" : "#7E869C"};
  border: 1px solid ${(props) => props.selected ? "#087E38" : "#CFCFE0"};
  position: relative;
`;

const Chip = styled('div')`
    padding: 4px;
    font-size: 12px;
    transition: none !important;
    background: #DA1A44 !important;
    color: white !important;
    position: absolute !important;
    right: 0 !important;
    top: -14px !important;
    border-radius: 20px !important;
`;

const Filters = ({ countryId, name, hasActiveWarehouse }: CountryModel) => {
  const { languageId } = useAppSelector(state => state.messagesReducer);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const selectedCountry = searchParams.get('country');
  const { language } = useParams();

  const filter = () => {
    if (countryId === 0) {
      navigate({
        pathname: `/${language}/online-stores`,
        search: createSearchParams({}).toString()
      });
      return;
    }
    if (hasActiveWarehouse) {
      navigate(`?country=${countryId}`);
    }
  }

  return (
    <Wraper role="button" onClick={filter} selected={countryId === Number(selectedCountry)}>
      {name === 'All' ? name : name[languageId]}
      {!hasActiveWarehouse && (
        <Chip> <Message messageKey={'coming_soon'} sectionId={MessageSections.ORDERS} /></Chip>
      )}
    </Wraper>
  );
}

export default Filters;
